import React, { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Icon, IconHighlight, Typography } from '@ann/web-components';
import { useDashboardData } from '../../context';
import { DASHBOARD_LIST_COPY } from '../../constants/dashboardBuilderCopy';
import DashboardCard from '../DashboardCard';
import {
  Container,
  EmptyCard,
  TemplatesSection,
  TemplatesGrid,
} from './DashboardEmptyState.styled';

const noop = () => {};

const DashboardEmptyState = () => {
  const navigate = useNavigate();
  const { templates, fetchTemplates } = useDashboardData();
  const { emptyState } = DASHBOARD_LIST_COPY;

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  const suggestedTemplates = useMemo(() => templates.slice(0, 3), [templates]);

  return (
    <Container>
      <EmptyCard>
        <IconHighlight bgColor="Primary" icon="grid" iconColor="PrimaryAlt" size="medium" />
        <Typography category="subtitle" weight="bold" size="medium" color="title">
          {emptyState.title}
        </Typography>
        <Typography category="body" weight="regular" size="medium" color="body">
          {emptyState.description}
        </Typography>
        <Button
          label={emptyState.createButton}
          iconRight="plus"
          type="primary"
          size="medium"
          onClick={() => navigate('new')}
        />
      </EmptyCard>

      {suggestedTemplates.length > 0 && (
        <TemplatesSection>
          <Typography category="subtitle" weight="bold" size="small" color="subtitle">
            {emptyState.suggestedTemplates}
          </Typography>
          <TemplatesGrid>
            {suggestedTemplates.map((template) => (
              <DashboardCard
                key={template.id}
                dashboard={template}
                onEdit={noop}
                onShare={noop}
                onArchive={noop}
                onDuplicate={noop}
              />
            ))}
          </TemplatesGrid>
        </TemplatesSection>
      )}
    </Container>
  );
};

export default DashboardEmptyState;
